
import { defineComponent } from "vue";
import Level1Icon from "@/assets/level_1.svg";
import Level2Icon from "@/assets/level_2.svg";
import Level3Icon from "@/assets/level_3.svg";

export default defineComponent({
  props: {
    level: {
      type: Number,
    },
  },
  components: {
    Level1Icon,
    Level2Icon,
    Level3Icon,
  },
});
